<template>

<CrearUsuario></CrearUsuario>

</template>


<script>

import CrearUsuario from '../../components/Seguimiento.vue';

export default {


 components:{

     CrearUsuario

  }

}


</script>